__turbopack_context__.v({
  "root": "iSPdMG_root",
  "web": "iSPdMG_web",
});
